const zIndex = {
  POPOVER: 3,
  HEADER: 10,
  STICKY_FOOTER: 99,
  STAGING_BANNER: 100,
} as const;

export default zIndex;
